import popupStyles from "./deleteConfirmation.module.css";
import { IPopupWithoutProps } from "../../../types/types";
import venchyImg from "../../../images/questionnaire_doctor.png";
import { tWithKeyAttr as t } from "../../../i18nHelper";


function DeleteConfirmation({
  onClose,
  onDelete,
  text,
  btnText = t('CONFIRM'),
  warningDetail,
}: IPopupWithoutProps & {
  onDelete: () => void;
  text: string;
  btnText?: string;
  /** Extra emphasized warning shown below the main message (e.g. irreversible actions). */
  warningDetail?: string;
}) {
  return (
    <article className={popupStyles.popup} data-testid="delete-confirmation-popup">
      <img className={popupStyles.popup__img} src={venchyImg} alt={t('VENCHI')} />
      <p className={popupStyles.popup__text}>{text}</p>
      {warningDetail ? (
        <p className={popupStyles.popup__warningDetail} role="alert">
          {warningDetail}
        </p>
      ) : null}
      <button
        className={`button ${popupStyles.popup__nextBtn} hover`}
        data-testid="confirm-deletion-button"
        onClick={() => {
          onDelete();
          onClose();
        }}
      >
        {btnText}
      </button>
    </article>
  );
}

export default DeleteConfirmation;
